import React from 'react'
import { Arc } from 'react-konva'

const EstimatedPointDot = ({ x, y }) => {
    return <Arc angle={360} outerRadius={3} x={x} y={y} fill="#D99EF7" />
}

export default EstimatedPointDot
